import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import TourSlideshow from '../components/home/TourSlideshow';
import FeaturedTours from '../components/home/FeaturedTours';
import ServicesSection from '../components/home/ServicesSection';
import HappyTravelers from '../components/home/HappyTravelers';
import WhyChooseUs from '../components/home/WhyChooseUs';
import VideoIntro from '../components/home/VideoIntro';
import GalleryCarousel from '../components/home/GalleryCarousel';
import ReviewSection from '../components/home/ReviewSection';
import ScrollingAircraft from '../components/ui/ScrollingAircraft';
import { Tour } from '../types';

const HomePage: React.FC = () => {
  const navigate = useNavigate();

  const handleTourSelect = (tour: Tour) => {
    navigate(`/tours/${tour.tourId}`);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      {/* Scrolling Aircraft */}
      <ScrollingAircraft />

      {/* Tour Slideshow Hero Section */}
      <TourSlideshow onTourSelect={handleTourSelect} />

      {/* Services Section */}
      <ServicesSection />

      {/* Happy Travelers Section */}
      <HappyTravelers />

      {/* Popular Destinations Section */}
      <FeaturedTours />

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* Gallery Carousel */}
      <GalleryCarousel />

      {/* Video Introduction */}
      <VideoIntro />

      {/* Reviews carousel — last section above footer */}
      <ReviewSection />
    </motion.div>
  );
};

export default HomePage;
